export function normalizeRoute(url?: string | null): string {
    const value = (url ?? '').trim();
    if (!value) {
        return '';
    }
    if (value.startsWith('http://') || value.startsWith('https://')) {
        return '';
    }
    return value.startsWith('/') ? value : `/${value}`;
}

export function normalizeSidebarHref(route?: string | null): string {
    let path = normalizeRoute(route);
    if (!path) {
        return '';
    }

    if (normalizePath(path) === '/api') {
        path = '/api-documentacao';
    }

    if (path.length > 1 && path.endsWith('/')) {
        return path.slice(0, -1);
    }

    return path;
}

export function normalizePath(url: string): string {
    const path = (url || '').split('?')[0].split('#')[0];
    if (path.length > 1 && path.endsWith('/')) {
        return path.slice(0, -1);
    }
    return path || '/';
}

export function isRouteMatch(currentUrl: string, route: string): boolean {
    if (!route) {
        return false;
    }
    const current = normalizePath(currentUrl);
    const target = normalizePath(route);
    return current === target || current.startsWith(`${target}/`);
}
